import React, { FC } from 'react';
import { Box } from '@mui/material';
import PillType from 'utils/constants/pillType';

interface IPill {
  type: PillType;
}

const Pill: FC<IPill> = ({ type }) => {
  const pillColor = {
    Beta: 'warning.light',
  };

  return (
    <Box
      sx={{
        width: '55px',
        height: '28px',
        fontSize: '14px',
        bgcolor: pillColor[type],
        borderRadius: '20px',
        display: 'grid',
        alignItems: 'center',
        color: 'background.default',
      }}
    >
      {type}
    </Box>
  );
};

export default Pill;
